/**
 * Shared constants for the auto-playing tutorial demo engine.
 *
 * The demo engine lets a scripted cursor drive the REAL app pages while a
 * mock HTTP layer (see demo-mock.interceptor.ts) fakes the backend, so the
 * whole experience can be screen-recorded without a server running.
 */

/** The flows that can be played as standalone tutorial clips. */
export type DemoFlow = 'customer' | 'product' | 'invoice';

export const DEMO_FLOWS: readonly DemoFlow[] = ['customer', 'product', 'invoice'];

/** Stable id used for the fake company the demo operates inside. */
export const DEMO_COMPANY_ID = 'demo-co-0001';

/** Where each flow begins (the list page, so the cursor can click "New X"). */
export const DEMO_FLOW_START_ROUTE: Record<DemoFlow, string> = {
  customer: '/customers',
  product: '/products',
  invoice: '/sales',
};

export const DEMO_FLOW_LABEL: Record<DemoFlow, string> = {
  customer: 'Müşteri Ekle',
  product: 'Ürün Ekle',
  invoice: 'Satış Gir',
};

/** Title-card ("thumbnail") shown for a beat at the start of each clip. */
export interface DemoIntro {
  step: string;
  title: string;
  subtitle: string;
}

export const DEMO_FLOW_INTRO: Record<DemoFlow, DemoIntro> = {
  customer: { step: '01', title: 'Müşteri Ekleme', subtitle: 'Yeni bir müşteri kaydı nasıl oluşturulur?' },
  product: { step: '02', title: 'Ürün & Hizmet Ekleme', subtitle: 'Kataloğunuza yeni bir ürün nasıl eklenir?' },
  invoice: { step: '03', title: 'Satış Faturası & e-Fatura', subtitle: 'Fatura oluşturup e-Fatura nasıl gönderilir?' },
};
